export default {
  保存: '保存',
  请输入链接: '请输入链接',
  添加联系人: '添加联系人',
  设为云展系统3D封面: '设为云展系统3D封面',
  建议比例: '建议比例',
  剩余可添加数据量: '剩余可添加数据量',
  张: '张',
  最多上传: '最多上传',
  添加图片: '添加图片',
  招标行业: '招标行业',
  招标公告: '招标公告',
  立即参展: '立即参展',
  我的: '我的',
  立即添加: '立即添加',
  上传视频: '上传视频',
  添加企业漫游提示2: '为了方便国内外客户浏览云展系统,我们有分两种不同版本的语言内容,请选择您要编辑的语言内容版本。',
  完成: '完成',
  显示: '显示',
  隐藏: '隐藏',
  确定要显示吗: '确定要显示吗',
  确定要隐藏吗: '确定要隐藏吗',
  标题链接: '标题/链接',
  封面: '封面',
  公开展示: '公开展示',
  添加企业漫游提示1: '企业漫游添加/编辑需要人工审核',
  刷新: '刷新',
  拖动排序按钮可以调整展示顺序: '拖动排序按钮可以调整展示顺序',
  管理云企业: '管理云企业',
  暂无云视频: '暂无云视频',
  暂无云企业: '暂无云企业',
  添加企业漫游: '添加企业漫游',
  提交审核成功: '提交审核成功',
  展示内容设置: '展示内容设置',

  管理: '管理',
  已收藏: '已收藏',
  推荐: '推荐',
  收起: '收起',
  展开: '展开',
  暂无: '暂无',
  工商信息: '工商信息',
  企业信息编辑: '企业信息编辑',
  详细地址: '详细地址',
  上市代码: '上市代码',
  交易机构: '交易机构',
  国家: '国家',
  企业员工数量: '企业员工数量',
  长度超出最大限制: '长度超出最大限制',
  不能为空: '不能为空',
  ch_提示3: '图片上传建议比例为1:1,大小限制2M以内',
  ch_提示2: '企业信息修改需要人工审核,审核通过后会更新为最新信息',
  ch_提示1: '为了方便国内外客户浏览云展系统,我们有分两种不同版本的语言内容,请选择您要编辑的语言内容版本。',
  请选择您要编辑的语言版本: '请选择您要编辑的语言版本',
  企业联系信息编辑: '企业联系信息编辑',
  国际版内容: '国际版内容',
  中文版内容: '中文版内容',
  导航: '导航',

  ch_联系我们: '联系我们',
  ch_云同事: '云同事',
  ch_云伙伴: '云伙伴',
  ch_云荣誉: '云荣誉',
  ch_云相册: '云相册',
  ch_对外投资: '对外投资',
  ch_投资机构: '投资机构',
  ch_云招标: '云招标',
  ch_云采购: '云采购',
  ch_云动态: '云动态',
  ch_云头条: '云头条',
  ch_云直播: '云直播',
  ch_云招商: '云招商',
  ch_云优惠: '云优惠',
  ch_云会议: '云会议',
  ch_云展览: '云展览',
  ch_云产品: '云产品',
  ch_云视频: '云视频',
  ch_云企业: '云企业',
}
